import styled from "styled-components";

const DropDownButtonStyle = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

  * {
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif !important;
  }

  position: relative;
  width: 100%;
  z-index: 100;


  /* Main Button */
  .DropBtn {
    width: auto; /* Changed from 100% to auto to hug content */
    min-width: 110px!important; /* Reduced 50% as requested */
    background: #7367f0;
    padding: 10px 14px; /* Reduced padding */
    display: flex;
    flex-direction: column;
    align-items: stretch;
    color: white;
    font-size: 13px; /* Slightly smaller font */
    font-weight: 600;
    border: none;
    cursor: pointer;
    border-radius: 12px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
    position: relative;
    white-space: nowrap;

    &:hover {
      background: #5a4fcf;
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(115, 103, 240, 0.35);
    }

    &:active,
    &:visited,
    &:focus,
    &:active:focus {
      outline: none !important;
      border: none !important;
    }
  }

  .DropBtn.open {
    border-radius: 12px 12px 0 0;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
  }

  /* Button Content */
  .content-text-icon {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 8px;
  }

  /* Arrow/Gear Icon Size Fix */
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px; 
    height: 16px;
    font-size: 14px; /* Constraint font-size for FA icons */
  }
  
  .icon svg {
    width: 100%;
    height: 100%;
  }

  /* Dropdown Menu */
  .optionsDrop {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 100%; /* Match button width at minimum */
    width: max-content; /* Allow expansion for long content */
    background: white;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border: 1px solid #e5e7eb;
    border-top: none;
    padding: 8px;
    z-index: 9999;
    max-height: 400px;
    overflow-y: auto;
    text-align: left; /* Ensure text aligns left even if button is centered */
  }

  .optionsDrop.open {
    display: block;
  }

  /* Scrollbar styling */
  .optionsDrop::-webkit-scrollbar {
    width: 6px;
  }

  .optionsDrop::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 3px;
  }

  .optionsDrop::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
  }

  .optionsDrop::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }

  /* Menu Items */
  .items {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    color: #374151;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    gap: 8px;
    white-space: nowrap;

    &:hover {
      background: #f8f7ff;
      color: #7367f0;
    }

    p {
      margin: 0;
      flex: 1;
    }
  }

  .items.open {
    background: #f0f0ff;
    color: #7367f0;
  }

  .items.hidden {
    display: none;
  }

  /* Icons in items */
  .ic {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    color: #9ca3af;
    font-size: 12px;
  }

  .items:hover .ic {
    color: #7367f0;
  }

  /* Active indicator - pure CSS dot */
  .icon-active {
    display: none;
    width: 8px;
    height: 8px;
    background: #10b981;
    border-radius: 50%;
    margin-left: auto; /* Push to right */
    flex-shrink: 0;
  }

  .icon-active.open {
    display: block;
  }
  
  /* Remove FA styles from .icon-active children since we use CSS dot */
  .icon-active svg {
    display: none;
  }

  /* Responsive */
  @media (max-width: 576px) {
    .DropBtn {
      min-width: 100%;
      padding: 12px 16px;
    }

    .content-text p {
      font-size: 13px;
    }

    .items {
      padding: 10px 12px;
      font-size: 13px;
    }
  }
`;

export default DropDownButtonStyle;
